import './style.css';
import { Game } from '@/app/game';
import { App } from '@/ui/app';
import { initLang } from '@/i18n';
import { setupPwa } from '@/pwa';

const canvas = document.getElementById('stage');
if (!(canvas instanceof HTMLCanvasElement)) throw new Error('Missing #stage canvas');
// The player's language first: it's a chunk of its own, preloaded by the page
void initLang().then(() => {
  const game = new Game(canvas);
  const app = new App(game);
  setupPwa();

  // Test facade for headless E2E and visual review: poll sim state rather than
  // wall time. Loaded on demand so it never ships to players.
  if (import.meta.env.DEV || new URLSearchParams(location.search).get('test') === '1') {
    void import('@/dev/hooks').then((m) => m.installHooks(game, app));
  }
});
